import type { GameStore } from '../core/store';
import { getSpecies } from '../game/data/species';
import { RISONANZA_COLOR } from '../game/data/risonanze';
import { isFainted } from '../game/lumine';
import { battlerUrl } from './creatureArt';
import { el } from './dom';

/** HUD di esplorazione: squadra a colpo d'occhio + scorta di Risonatori. */

export class Hud {
  private container: HTMLDivElement;
  private teamChip: HTMLDivElement;
  private itemChip: HTMLDivElement;
  private noticeEl: HTMLDivElement;
  private noticeTimer = 0;

  constructor(uiRoot: HTMLElement, store: GameStore) {
    this.container = el('div', 'hud');
    this.teamChip = el('div', 'hud-chip');
    this.itemChip = el('div', 'hud-chip');
    this.container.append(this.teamChip, this.itemChip);
    uiRoot.appendChild(this.container);

    this.noticeEl = el('div', 'notice panel');
    uiRoot.appendChild(this.noticeEl);

    store.events.on('teamChanged', () => this.refresh(store));
    store.events.on('inventoryChanged', () => this.refresh(store));
    store.events.on('notice', ({ text }) => this.showNotice(text));
    this.refresh(store);
  }

  refresh(store: GameStore): void {
    this.teamChip.replaceChildren();
    const { team, inventory } = store.state.player;
    if (team.length === 0) {
      this.teamChip.textContent = 'Nessun Lumine';
    } else {
      for (const lumine of team) {
        const dot = el('span', 'dot');
        const species = getSpecies(lumine.speciesId);
        dot.style.background = isFainted(lumine) ? '#888' : RISONANZA_COLOR[species.risonanza];
        dot.title = `${species.name} Lv.${lumine.level}`;
        this.teamChip.appendChild(dot);
      }
      const lead = team.find((l) => !isFainted(l)) ?? team[0]!;
      const avatar = el('img', 'chip-avatar');
      avatar.src = battlerUrl(lead.speciesId);
      avatar.alt = '';
      this.teamChip.prepend(avatar);
      this.teamChip.appendChild(
        el('span', undefined, `${getSpecies(lead.speciesId).name} Lv.${lead.level}`),
      );
    }
    this.itemChip.textContent = `◉ Risonatori: ${inventory.risonatori}`;
  }

  showNotice(text: string): void {
    this.noticeEl.textContent = text;
    this.noticeEl.classList.add('visible');
    window.clearTimeout(this.noticeTimer);
    this.noticeTimer = window.setTimeout(() => this.noticeEl.classList.remove('visible'), 2600);
  }

  setVisible(visible: boolean): void {
    this.container.style.display = visible ? 'flex' : 'none';
  }
}
